import $ from 'jquery';
import {checkoutLookupCompany} from "./lookupcompany";
import {addToCart} from "../ecommercetracking";

$(document).ready(function () {
    $.fn.dataTable.ext.classes.sPageButton = 'pagination__item';

    //LOOKUP COMPANY
    var createTable = function () {
        return $('#lookupcompanytable').DataTable({
            "lengthChange": false,
            "responsive": true,
            "autoWidth": true,
            "pagingType": "simple_numbers", 
            "pageLength": 10,
            "order": [],
            "language": {
                "emptyTable": "Kontrollera stavningen eller att företaget du söker efter är ett aktiebolag.",
                "paginate": {
                    "previous": "<",
                    "next": ">",
                    "first": "<<",
                    "last": ">>",
                }
            },
            drawCallback: function (settings) {
                $('.orderflow__companylist').removeClass('d-none');
                var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
                pagination.toggle(this.api().page.info().pages > 1);
            },
            "initComplete": function (settings, json) {
                $('#lookupcompanytable_wrapper').removeClass('form-inline');
                $('#lookupcompanytable_wrapper .col-sm-5').removeClass('col-sm-5');
                $('#lookupcompanytable').show();
            },
        });
    }

    var ldt = createTable();

    $(".orderflow__intro-searchfield").keydown(function (e) {

        if (e.keyCode === 13) {
            var isValid = e.currentTarget.checkValidity();
            if (isValid) {
                checkoutLookupCompany($(".orderflow__intro-searchfield").val(),
                    ".orderflow__companylist",
                    ldt,
                    createTable);
            } else {
                e.currentTarget.reportValidity();
            }
        }
    });

    $("#lookupcompanytable").addClass('fade-in one');
    $("#lookupcompanytable").show();

    //VERIFY ACCOUNT
    var currentStep = 1;
    $(".steps__item-badge").each(function () {
        $(this).append(currentStep);
        currentStep++;
    });

    //KLARNA
    $(".js__switch-client-type").click(function (e) {
        e.preventDefault();
        $("#switch-client-type-form").submit();
    });
});  